// get the currently auth'd user stats such as number of prompts, conversations
// started and conversations received
// used in profilepage/ProfileStats.js
import {
  collection,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { firestore } from '../firebase';
import { GET_MY_STATS } from './types';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from './asyncActions';

export const getMyStats = () => async (dispatch, getState) => {
  dispatch(asyncActionStart());
  try {
    const user = getState().auth.currentUser;
    const userID = user.uid;

    // get number of prompts user made
    const promptsCollectionRef = collection(firestore, 'prompts');
    const promptsQuery = query(
      promptsCollectionRef,
      where('creatorID', '==', userID)
    );
    const promptsSnapshot = await getDocs(promptsQuery);
    const promptsNumber = promptsSnapshot.docs.length;

    // // get number of conversations the user is in
    // const conversationsQuery = query(
    //   collection(firestore, 'conversations'),
    //   where('participantsIDs', 'array-contains', userID)
    // );
    // const conversationsSnapshot = await getDocs(conversationsQuery);
    // const conversationsNumber = conversationsSnapshot.docs.length;

    // get number of conversations the user has started
    const conversationsCollectionRef = collection(firestore, 'conversations');
    const conversationsStartedQuery = query(
      conversationsCollectionRef,
      where('conversationStarterID', '==', userID)
    );
    const conversationsStartedSnapshot = await getDocs(conversationsStartedQuery);
    const conversationsStartedNumber = conversationsStartedSnapshot.docs.length;

    // get number of conversations the user has received
    const conversationsReceivedQuery = query(
      conversationsCollectionRef,
      where('promptCreatorID', '==', userID)
    );
    const conversationsReceivedSnapshot = await getDocs(conversationsReceivedQuery);
    const conversationsReceivedNumber =
      conversationsReceivedSnapshot.docs.length;

    dispatch({
      type: GET_MY_STATS,
      payload: {
        promptsNumber,
        conversationsStartedNumber,
        conversationsReceivedNumber
      }
    });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.error(error);
    dispatch(asyncActionError());
  }
};
